// extracted by mini-css-extract-plugin
module.exports = {"titleTools":"styles_titleTools__2bJvm","expander":"styles_expander__sZzdy"};